import {
  createShop as _createShop,
  deleteShop as _deleteShop,
  getShops as _getShops,
} from "@/services/api/ec";
import { useCallback, useEffect, useState } from "react";

export default () => {
  const [shops, setShops] = useState<any[]>([]);
  const [refresh, setRefresh] = useState(false);

  const getShops = useCallback(() => {
    _getShops().then((data) => {
      setShops(data);
    });
  }, []);

  const createShop = useCallback(
    (shop: any) => {
      _createShop(shop).then(() => {
        getShops();
      });
    },
    [shops]
  );

  const deleteShop = useCallback(
    (shopId: string) => {
      _deleteShop(shopId).then(() => {
        getShops();
      });
    },
    [shops]
  );

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        getShops();
        setRefresh(false);
      }, 500);
    }
  }, [refresh]);

  useEffect(() => {
    getShops();
  }, []);

  return {
    shops,
    getShops,
    createShop,
    deleteShop,
    setRefresh,
  };
};
